// extracted by mini-css-extract-plugin
module.exports = {"dropbox":"styles_dropbox__X4BLs","verticalLine":"styles_verticalLine__jbh_Q"};